module.exports = __webpack_public_path__ + "static/AL_training_gif2_opti-5c8557c8e6cb0c5947d1a8117ed6ed39.gif";